export const modals = {
  common: {
    ok: 'Ok',
    close: 'Close',
    okay: 'Okay',
  },
  minimumAge: {
    title: 'Age restriction',
    message: 'You must be at least {{age}} years old.',
  },
  accountBlocked: {
    title: 'Account blocked',
    heading: 'Account blocked',
    permanent: 'This account has been permanently banned.',
    temporary: 'This account has been banned.',
    temporaryUntil: 'This account is banned until {{date}}.',
    reason: 'Reason: {{reason}}',
  },
  insufficientBalance: {
    title: 'Insufficient funds',
    description: 'Top up now and jump back into the game.',
    cta: 'Top up balance',
  },
  chestNotPlayed: {
    title: 'Daily reward locked',
    heading: "Let's play",
    description: 'Play at least one game today to unlock the chest.',
    cta: 'Play now',
  },
  chestAlreadyOpened: {
    title: 'Come back tomorrow',
    message: "You have already opened today's chest.",
  },
  chestUnlocked: {
    title: 'Reward unlocked',
    modalDescription:
      'You’ve earned a reward! Go now and open your chest to see what’s inside.',
    heading: 'Reward unlocked',
    description:
      'You’ve earned a reward! Go now and open your chest to see what’s inside.',
    cta: 'Go to Rewards',
  },
  paymentResult: {
    successTitle: 'Payment success',
    successDescription: 'Payment was completed successfully.',
    failureTitle: 'Payment failed',
    failureDescription: 'Payment was not completed. Please try again.',
  },
  winMore: {
    title: 'Want to win more?',
    heading: 'WANT TO WIN MORE?',
    description:
      'Higher entry fee - bigger wins. Top up your balance to play in the higher league.',
    cta: 'Add funds',
  },
  winRealMoney: {
    title: 'Want to win real money?',
    heading: 'WANT TO WIN REAL MONEY?',
    description:
      'Just top-up your wallet and play against real opponents. Start earning now!',
    cta: 'Top up balance',
  },
  goPlay: {
    title: "LET'S START PLAYING",
    heading: "LET'S START PLAYING",
    subtitle: 'Pick a game and start in seconds',
  },
};
